export default {
  // Page title
  'layout.pass': '通过',
  'layout.reject': '拒绝',
  'layout.open': '打开',
  'layout.close': '关闭',
};
